export default {
  user: {}, // user
  deviceId: "", // to sign in if cognito session is invalid
  tenantCode: "", // not used?
  staff: {}, // current staff data
  lastLoginDateTime: "", // Invalidate user over 1 week( - deprecated) 本来は、一週間経ったらリフレッシュトークンを取り直すみたいなことをやりたいと考えていた。
  guest: {}, // guest,
  isUserLoggedOut: true,
  oneTimeToken: "",
  userAgent: "",
  subscriptionEndpoint: "",
  accessToken: "",
  refreshToken: "",
};
